var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-header",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.path.indexOf("/auth/APIAuth") == -1,
              expression: "$route.path.indexOf('/auth/APIAuth') == -1"
            }
          ],
          staticClass: "my-el-header",
          style: _vm.computedStyle
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "jzq-logo" }, [
              _c("img", {
                attrs: { src: "/images/logo/jzq-logo.png", width: "300px" }
              })
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.isInDingTalk &&
                      _vm.$route.path.indexOf("/auth/dingTalkAuth") == -1,
                    expression:
                      "isInDingTalk && $route.path.indexOf('/auth/dingTalkAuth') == -1"
                  }
                ],
                staticClass: "right-position",
                on: { click: _vm.toIndex }
              },
              [
                _c("i", { staticClass: "el-icon-d-arrow-left" }),
                _vm._v("\n        返回首页\n      ")
              ]
            )
          ])
        ]
      ),
      _c("div", { staticClass: "y-header", staticStyle: { height: "60px" } }),
      _c("el-main", { style: { "min-height": _vm.height } }, [_c("nuxt")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19773bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19773bf2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/fullpage.vue
// module id = oa64
// module chunks = 201